import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { getOrgPropertiesFn, updateOrgPropertiesFn } from "@/api/ordersApi"
import { OrgProperties } from "@/shared/types"
import { showToast } from "@/shared/utils"

export const rateConOrgPropertyKeys = [
  OrgProperties.RATE_CON_INTEGRATION,
  OrgProperties.FEATURE_FLAG_RATE_CON_EMAIL_ENABLED,
  OrgProperties.RATE_CON_EMAIL,
  OrgProperties.RATE_CON_EMAIL_SENDER,
  OrgProperties.RATE_CON_CONFIRMATION_TIMEOUT_MINUTES,
  OrgProperties.FEATURE_FLAG_DISABLE_CRITICAL_AUTO_WINNER_AWARD,
]

export const useRateConOrgProperties = (orgId: string) => {
  return useQuery(
    ["rateConOrgProperties", orgId],
    () => getOrgPropertiesFn(orgId, rateConOrgPropertyKeys),
    {
      enabled: !!orgId,
      staleTime: 30 * 1000,
      onError: (error) => {
        if (isAxiosError(error)) {
          showToast({ type: "error", text: error.response?.data.errorMessage || error.message })
        }
      },
    },
  )
}

export const useUpdateRateConOrgProperties = (orgId: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    (properties: { propertyKey: OrgProperties; value: string }[]) =>
      updateOrgPropertiesFn(orgId, properties),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["rateConOrgProperties", orgId])
        queryClient.invalidateQueries(["allOrgProperties"])
        showToast({ type: "success", text: "Rate confirmation settings saved." })
      },
      onError: (error) => {
        if (isAxiosError(error)) {
          showToast({ type: "error", text: error.response?.data.errorMessage || error.message })
        }
      },
    },
  )
}
